import * as React from 'react';
import { Button, FormCell, Grid } from 'ui-toolkit';
import { IRecordedDeed } from '../classes/RecordedDeed';
import getText from '../utils/getText';
import DateText from './fields/DateText';

interface IExistingRecordedDeed {
  data: IRecordedDeed;
  onEditClick: (title?: string) => void;
}

// tslint:disable-next-line:function-name
const ExistingRecordedDeed: React.FunctionComponent<IExistingRecordedDeed> = (props) => {
  const onAddClick = () => {
    props.onEditClick(getText('recordedDeed.addNew'));
  };

  return (
    <Grid>
      <h2>{`${getText('recordedDeed.existing')} Details`}</h2>
      <Grid columnCount={4}>
        <FormCell label={'Recorded date'}>
          <DateText date={props.data.recorded_date} />
        </FormCell>
        <FormCell label={'Executed date'}>
          <DateText date={props.data.execution_date} />
        </FormCell>
      </Grid>
      <Grid columnWidth={'min-content'}>
        <Button intent="ghost" isInline onClick={onAddClick}>{`+ ${getText('recordedDeed.addNew')}`}</Button>
      </Grid>
    </Grid>
  );
};

export default ExistingRecordedDeed;
